import { render } from "./watermark-decryption.vue?vue&type=template&id=1273f44c&scoped=true&ts=true"
import script from "./watermark-decryption.vue?vue&type=script&lang=ts"
export * from "./watermark-decryption.vue?vue&type=script&lang=ts"

import "./watermark-decryption.vue?vue&type=style&index=0&id=1273f44c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1273f44c"]])

export default __exports__